module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/get-own-property-descriptor.js
 ** module id = 440
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/